export default "__VITE_ASSET__FhB_XO7v__"